import classNames from 'classnames';
import styled from 'styled-components';

import type { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { ScarcityIcon } from '@sorare/core/src/atoms/icons/ScarcityIcon';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { Tab, TabBar } from '@sorare/core/src/atoms/navigation/TabBar';
import { LabelL, LabelM } from '@sorare/core/src/atoms/typography';
import { useMenu } from '@sorare/core/src/contexts/graphql-search';
import { useIsLaptop } from '@sorare/core/src/hooks/device/useIsLaptop';

import { MyCardsRaritySwitcherBox } from '#src/components/myCards/MyCardsRaritySwitcherBox/index.tsx';

const StyledTabBar = styled(TabBar)`
  margin: 0 var(--unit);
`;

export const BackendRevealableCardRaritySwitcher = () => {
  const isLaptopAndAbove = useIsLaptop();
  const { value, refine, items } = useMenu('revealRarity');
  const selectedRarity = value as Rarity | undefined;

  if (!isLaptopAndAbove) {
    return (
      <StyledTabBar scrollable value={selectedRarity}>
        {items.map(({ value: rarity, count }, key) => (
          <Tab key={key} onClick={() => refine(rarity)} value={rarity}>
            <ScarcityIcon rarity={rarity as Rarity} size={2} />
            <LabelL bold>{count}</LabelL>
          </Tab>
        ))}
      </StyledTabBar>
    );
  }

  return (
    <Horizontal>
      {items.map(({ value: rarity, count }, key) => (
        <MyCardsRaritySwitcherBox
          key={key}
          className={classNames({ active: rarity === selectedRarity })}
          onClick={() => refine(rarity)}
        >
          <ScarcityIcon rarity={rarity as Rarity} size={5} />
          <LabelM bold>{count}</LabelM>
        </MyCardsRaritySwitcherBox>
      ))}
    </Horizontal>
  );
};
